module.exports = __webpack_public_path__ + "img/hqc-siegel-64x64.72a03260.png";